<!-- Copyright (C) nexleader - All Rights Reserved -->
<!-- Unauthorized copying of this file, via any medium is strictly prohibited -->
<!-- Proprietary and confidential -->
<!-- Written for nexleader <myipsat.com>, 2016-2018 -->

<div class="login-container">
  <div class="row m-b-md">
    <div class="col-md-12">
      <div class="text-center m-b-md">
        <div class="text-center m-b-md">
          <img src="/assets/images/logo.svg" width="125" height="100" />
        </div>
      </div>
      <div class="text-center">
        <p>Thanks. Your coach evaluation has been submitted.</p>
        <br />
        <a class="btn btn-success" [routerLink]="['/']">Login</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 text-center">
      <strong>IPSAT</strong> <br />
      {{ currentYear }} Copyright nexleader
    </div>
  </div>
</div>